<template>
    <div class="video-slide">
        <div class="video-width" v-if="visible">
            <div class="video-aspect">
                <div class="video-make-height">
                    <div class="video-hide-controls">
                        <iframe :src="endPoint" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            videoId: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                visible: window.ViewPort.media !== 'small'
            }
        },
        computed: {
            endPoint() {
                return 'https://player.vimeo.com/video/' + this.videoId + '?background=1';
            }
        },
        mounted() {
            window.EventHandler.listen('window-resized', this.windowResized);
        },
        methods: {
            windowResized(data) {
                this.visible =  !(data.media === 'small');
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/js/src/components/VideoSlide.vue